export default __webpack_public_path__ + "static/media/DamasoNo34.90f46948.jpg";